import React from 'react';

import type { OnFail } from './types.tsx';

type UseRequestContextValue = {
  onFail?: OnFail;
  debounce?: number;
};

/*
  I've decided to avoid createContexts here because its "useContext" hook forces the user declare Provider if it is not required
 */
const useRequestContext = React.createContext<UseRequestContextValue>({});
export const UseRequestProvider = useRequestContext.Provider;

export const useRequestContextValue = () => React.useContext(useRequestContext);
